import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { filter, take, timeout } from 'rxjs/operators';
import { FrontendLoggerService } from '../../../services/frontend-logger.service';

export class WizardOnboardingTokenVerifier {
  constructor(
    private readonly auth0: Auth0Service,
    private readonly logger: FrontendLoggerService
  ) {}

  async refreshAndWait(waitMs: number): Promise<boolean> {
    try {
      try {
        await firstValueFrom((this.auth0 as any).getAccessTokenSilently({ cacheMode: 'off' }));
      } catch {
        await firstValueFrom((this.auth0 as any).getAccessTokenSilently({ ignoreCache: true }));
      }
    } catch (error) {
      this.logger.error(
        '[Wizard] Failed to silently refresh access token: '
          + String((error as any)?.message || error),
        'Wizard.refreshToken'
      );
      return false;
    }

    try {
      const claims = await firstValueFrom(
        this.auth0.idTokenClaims$.pipe(
          filter((value: any) => this.hasCompletedOnboardingClaims(value) && this.hasRoleClaim(value)),
          take(1),
          timeout(waitMs)
        ) as any
      );
      return !!claims;
    } catch {
      return false;
    }
  }

  hasCompletedOnboardingClaims(claims: any): boolean {
    if (!claims) return false;
    const namespaced = claims['https://www.innovadoc-ia.com/app_metadata'] || {};
    const app = claims.app_metadata || {};
    return this.isTruthyFlag(namespaced.WizardCompleted)
      || this.isTruthyFlag(namespaced.WizarCompleted)
      || this.isTruthyFlag(app.WizardCompleted)
      || this.isTruthyFlag(app.WizarCompleted)
      || this.isTruthyFlag(claims.WizardCompleted)
      || this.isTruthyFlag(claims.WizarCompleted);
  }

  hasRoleClaim(claims: any): boolean {
    if (!claims) return false;
    return this.hasClaimValue(claims['https://www.innovadoc-ia.com/roles'])
      || this.hasClaimValue(claims['https://your-app.com/roles'])
      || this.hasClaimValue(claims.role);
  }

  isTruthyFlag(value: unknown): boolean {
    return value === true || (typeof value === 'string' && /^\s*(true|1|yes)\s*$/i.test(value));
  }

  hasClaimValue(value: unknown): boolean {
    if (Array.isArray(value)) {
      return value.some((item) => typeof item === 'string' && item.trim().length > 0);
    }
    return typeof value === 'string' && value.trim().length > 0;
  }
}
